import React from 'react';

export const FlamingoLogo = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg viewBox="0 0 100 100" className="w-full h-full">
        {/* Flamingo body */}
        <ellipse cx="50" cy="65" rx="18" ry="25" fill="#ec4899" className="drop-shadow-sm"/>
        
        {/* Flamingo neck */}
        <path d="M 35 50 Q 30 35 40 25" stroke="#ec4899" strokeWidth="8" fill="none" strokeLinecap="round"/>
        
        {/* Flamingo head */}
        <circle cx="42" cy="22" r="8" fill="#ec4899"/>
        
        {/* Beak */}
        <path d="M 38 25 L 32 28 L 38 28 Z" fill="#f97316"/>
        
        {/* Eye */}
        <circle cx="45" cy="20" r="2" fill="white"/>
        <circle cx="46" cy="19" r="1" fill="black"/>
        
        {/* Legs */}
        <line x1="45" y1="85" x2="45" y2="95" stroke="#f97316" strokeWidth="3"/>
        <line x1="55" y1="85" x2="55" y2="95" stroke="#f97316" strokeWidth="3"/>
        
        {/* Feet */}
        <path d="M 42 95 L 48 95" stroke="#f97316" strokeWidth="3" strokeLinecap="round"/>
        <path d="M 52 95 L 58 95" stroke="#f97316" strokeWidth="3" strokeLinecap="round"/>
        
        {/* Wing detail */}
        <ellipse cx="58" cy="60" rx="8" ry="15" fill="#f472b6" opacity="0.7"/>
      </svg>
    </div>
  );
};

export const FlamingoIcon = ({ className = 'w-6 h-6' }) => (
  <div className={className}>
    <svg viewBox="0 0 24 24" className="w-full h-full">
      <path 
        d="M12 2C13 2 14 3 13 5C13 6 12 7 11 8L10 12L12 18L11 20C10 21 9 20 9 19L8 15L6 12C5 11 5 10 6 9C7 8 8 7 8 6C8 4 9 2 12 2Z" 
        fill="currentColor"
      />
      <circle cx="10" cy="5" r="1" fill="white"/>
      <path d="M8 6L6 7" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
    </svg>
  </div>
);

export const FloatingFlamingo = () => (
  <div className="fixed bottom-4 right-4 opacity-30 pointer-events-none pfi-float">
    <FlamingoLogo size="lg" className="text-pink-400 filter drop-shadow-lg" />
  </div>
);